export default __webpack_public_path__ + "static/media/collage-icon.2056aa7d.svg";